var __jsx = React.createElement;
import React from 'react';
import Link from 'next/link';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

var ConsoTermsNotice = function ConsoTermsNotice(props) {
  var provider = props.provider,
      goBack = props.goBack;
  return __jsx(Container, null, __jsx(Row, null, __jsx(Col, {
    className: "p-3"
  }, __jsx("p", null, "Conform Regulamentului General privind Protec\u021Bia Datelor nr. 679/2016, CONSO MEDIA GROUP SRL are obligatia de a administra \xEEn condi\u021Bii de siguran\u021B\u0103 \u0219i numai pentru scopurile specificate, datele personale pe care ni le furniza\u021Bi despre dumneavoastr\u0103, un membru al familiei dumneavoastr\u0103 ori o alt\u0103 persoan\u0103."), __jsx("p", null, "Colectarea datelor dumneavoastr\u0103 este necesar\u0103 \xEEn vederea prelucr\u0103rii lor \u0219i transmiterii c\u0103tre partenerii contractuali ai CONSO MEDIA GROUP SRL, institu\u021Bii financiar-bancare de oferta c\u0103rora sunte\u021Bi interesat/\u0103. Pentru detalii privind modalita\u021Bile \xEEn care datele dumneavoastr\u0103 cu caracter personal sunt prelucrate de c\u0103tre noi, v\u0103 rug\u0103m s\u0103 accesati ", __jsx(Link, {
    href: "".concat(process.env.NEXT_PUBLIC_WEB, "/termeni/date-personale")
  }, __jsx("a", {
    target: "_blank",
    alt: "Politica de confiden\u021Bialitate"
  }, "Politica de confiden\u021Bialitate")), " si ", __jsx(Link, {
    href: "".concat(process.env.NEXT_PUBLIC_WEB, "/termeni/generali")
  }, __jsx("a", {
    target: "_blank",
    alt: "Termeni de utilizare"
  }, "Termenii de utilizare")), " ai portalului Conso", provider == 'BCR' && __jsx(React.Fragment, null, ", respectiv ", __jsx(Link, {
    href: "".concat(process.env.NEXT_PUBLIC_ENDAPI, "/assets/files/terms/privacy_policy_bcr.pdf")
  }, __jsx("a", {
    target: "_blank",
    alt: "Termeni BCR"
  }, "Politica de Confiden\u021Bialitate BCR"))), ".", provider == 'UniCredit Bank' && __jsx(React.Fragment, null, ", respectiv ", __jsx(Link, {
    href: "".concat(process.env.NEXT_PUBLIC_ENDAPI, "/assets/files/terms/privacy_policy_unicredit.pdf")
  }, __jsx("a", {
    target: "_blank",
    alt: "Termeni UniCredit Bank"
  }, "Politica de Confiden\u021Bialitate UniCredit Bank"))), "."), __jsx("p", null, "Prin completarea formularului, e\u0219ti de acord s\u0103 fii contactat de catre Conso Media Group SRL \u0219i institu\u021Biile financiare la care ai aplicat, \xEEn legatura cu solicitarea ta."), __jsx("p", null, "\xCEnteleg c\u0103 aceast\u0103 solicitare nu reprezint\u0103 depunerea unei cereri de credit la institu\u021Bia finan\u021Batoare."), __jsx(Button, {
    variant: "outline-secondary",
    onClick: goBack
  }, __jsx(FontAwesomeIcon, {
    icon: faChevronLeft,
    height: "16",
    width: "16",
    className: "mr-2"
  }), "\xCEnapoi"))));
};

export default ConsoTermsNotice;